import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=514f2b39"
import script from "./ShopDetail.vue?vue&type=script&lang=js"
export * from "./ShopDetail.vue?vue&type=script&lang=js"
import style0 from "./ShopDetail.vue?vue&type=style&index=0&id=514f2b39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports